export const ImageDesc91 = {
    title: "Image 91: Example of a prayer room.",
    para1: <>
        <p>This image is an example of a multi-faith prayer room. The room doesn't have any distinguishable features so as to have a neutral environment that would accommodate the faiths of people who may use it. The room is an empty room with an exit sign and a glass door. It is well-lit and the finishing of the walls and floor is of a neutral colour, where the ceiling is white, and the walls and flooring are grey in colour. There is a built-in lockable wall storage unit and a wooden bench is placed for seating.</p>
        <p>The room also leads to a wash area which has several washbasins made of ceramic with metal fixtures.</p>
    </>
}

export const ImageDesc92 = {
    title: "Image 92: Examples of Ablution for Prayer Rooms.",
    para1: <>
        <p>This image shows two pictures showing examples of ablution for prayer rooms.
        </p>
        <p>The image on the left shows the door to the room which is closed. The board on top of the door reads “Female Ablution” in English and Hindi. </p>
        <p>The image on the right shows the inside of the ablution room. The room has 4 raised seats on the floor made of white marble. There are four faucets in front of the four platforms. There is a drainage system below the faucets. There is a door on the left of the picture which is the entrance to the room. </p>
    </>
}